/**
 * Device-level app preferences. Deliberately not on the user row: this one
 * describes what the device should do, and a migration would need a manual
 * db:migrate against the company DB.
 */

export const AUTO_SCREENSHOT_KEY = 'cb.pref.autoScreenshot';

/** Off only when explicitly stored as '0'; anything else — unset, corrupt, storage blocked — reads as on. */
export function getAutoScreenshot(): boolean {
  try {
    return localStorage.getItem(AUTO_SCREENSHOT_KEY) !== '0';
  } catch {
    return true;
  }
}

export function setAutoScreenshot(on: boolean): void {
  try {
    localStorage.setItem(AUTO_SCREENSHOT_KEY, on ? '1' : '0');
  } catch {
    // Safari private mode / storage disabled by policy: the preference is not
    // worth breaking a settings screen over.
  }
}
